<template>
  <div class='df-list lh1' v-if="item.list.length">
    <div class="header flex aic jcb">
      <div class="flex aic">
        <i class="list-icon" :class="item.icon"></i>
        <p class="header-title">{{item.title}}</p>
      </div>
      <div class="flex aic csp header-convert" @click="changeConvert(item)" v-show="item.list.length > 10">
        <i class="list-icon convert_icon"></i>
        <p class="">{{isConvert ? '上一页' : '下一页'}}</p>
      </div>
    </div>
    <div class="content">
      <div class="content-item flex aic" v-for="(val,i) in currList" :key="i">
        <p class="fs20 content-count tac" :class="'content-color_'+(count+i+1)">{{count + i+1}}</p>
        <p class="flex-1 fs16 content-name csp wot1 " @click="goDetails(val,item.prop)">{{val.name | filterTitle}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DfList',
  filters: {
    filterTitle (text) {
      text = text ? text.split(/[:：]/) : '';
      return text[1] || text[0];
    }
  },
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  watch: {
    item (val) {
      this.currList = val.list.length > 10 ? val.list.slice(0, 10) : val.list;
    }
  },
  data () {
    return {
      currList: [],
      count: 0,
      isConvert: false,
    }
  },
  created () {

  },
  methods: {
    changeConvert (item) {
      this.isConvert = !this.isConvert;
      this.count = this.isConvert ? 10 : 0;
      let index = this.isConvert ? 1 : 0;
      this.currList = this.item.list.slice((index * 10), (index + 1) * 10);
    },
    goDetails (item, prop) {
      let url = '';
      switch (prop) {
        case 'course':
          url = `/home/${item.format_id === 1 ? 'video' : 'audio'}/details/${item.id}/${item.type}`;
          if(this.$route.query.subject_id){
            url += `?subject_id=${this.$route.query.subject_id}`;
          }
          break;
        case 'teacher':
          url = `/home/teacher/detail/${item.id}`;
          break;
        case 'keyword':
          url = `/home/search?keyword=${item.name}`;
          break;
      }
      prop !== 'keyword' ? this.OpenRouter(url) : this.$router.push(url);
    }
  }
}
</script>

<style scoped lang='less'>
@import '../../assets/less/function';
@act-color: #1177ff;

.list-icon {
  .spirit(url(../../assets/images/search_icon.png));
  &.icon_1 {
    &:after {
      width: 23px;
      height: 23px;
      background-position: -79px -35px;
    }
  }
  &.icon_2 {
    &:after {
      width: 23px;
      height: 23px;
      background-position: -53px -35px;
    }
  }
  &.icon_3 {
    &:after {
      width: 23px;
      height: 23px;
      background-position: -27px -35px;
    }
  }
  &.icon_4 {
    &:after {
      width: 23px;
      height: 23px;
      background-position: -2px -35px;
    }
  }
  &.convert_icon {
    margin-right: 3px;
    &:after {
      width: 14px;
      height: 14px;
      background-position: -47px -3px;
    }
  }
  &.convert_icon_hover {
    &:after {
      background-position: -62px -3px;
    }
  }
}
.df-list {
  padding: 10px 0 40px 12px;
}
.header {
  &-title {
    font-size: 22px;
    color: #333f4e;
    padding-left: 8px;
  }
  &-convert {
    color: #999fa6;
    font-size: 12px;
    &:hover {
      color: @act-color;
      .convert_icon {
        .list-icon .convert_icon_hover;
      }
    }
  }
}
.content {
  &-item {
    padding-top: 27px;
    line-height: 1.2;
  }
  &-count {
    width: 24px;
    font-family: Roboto;
  }
  &-name {
    padding-left: 13px;
    color: #3e4c5d;
    &:hover {
      color: @act-color;
    }
  }
  &-color_1 {
    background: linear-gradient(162deg, #ff5776 0%, #ff1f48 100%);
    .text_color;
  }
  &-color_2 {
    background: linear-gradient(162deg, #ff8247 0%, #ff5a0d 100%);
    .text_color;
  }
  &-color_3 {
    background: linear-gradient(162deg, #ffb04b 0%, #ff9100 100%);
    .text_color;
  }
  .text_color {
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
</style>
